import type React from 'react';
import { RiArrowDownSLine, Button } from '@itandi/itandi-bb-ui';

export const renderDropDownButton = (label: string): React.ReactElement => (
  <Button
    endIcon={<RiArrowDownSLine />}
    height="small"
    type="button"
    variant="secondary"
  >
    {label}
  </Button>
);
